"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.msalConfig = void 0;
const msalConfig = (auth) => {
    return {
        auth: Object.assign(auth, { navigateToLoginRequestUrl: false }),
        cache: {
            cacheLocation: 'sessionStorage',
            storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
        },
        // system: {
        //   loggerOptions: {
        //     loggerCallback: (level: any, message: any, containsPii: any) => {
        //       if (containsPii) {
        //         return;
        //       }
        //       switch (level) {
        //         case LogLevel.Error:
        //           console.error(message);
        //           return;
        //         case LogLevel.Info:
        //           console.info(message);
        //           return;
        //         case LogLevel.Verbose:
        //           console.debug(message);
        //           return;
        //         case LogLevel.Warning:
        //           console.warn(message);
        //           return;
        //       }
        //     },
        //   },
        // },
    };
};
exports.msalConfig = msalConfig;
